export default "__VITE_ASSET__mioh5BR8__"